export const DEFAULT_LOCALE = 'en';

export const normalizeLocale = locale => {
    if (Array.isArray(locale)) {
        return normalizeLocale(locale[0]);
    }

    if (typeof locale !== 'string') {
        return '';
    }

    const trimmedLocale = locale.trim();
    const localeKey = trimmedLocale.replace(/_/g, '-').toLowerCase();

    if (localeKey === 'en' || localeKey.startsWith('en-')) {
        return 'en';
    }

    if (
        localeKey === 'zh-hant' ||
        localeKey.startsWith('zh-hant-') ||
        /^zh-(tw|hk|mo)(-|$)/.test(localeKey)
    ) {
        return 'zh-hant';
    }

    if (
        localeKey === 'zh-hans' ||
        localeKey.startsWith('zh-hans-') ||
        /^zh-(cn|sg)(-|$)/.test(localeKey)
    ) {
        return 'zh-hans';
    }

    return trimmedLocale;
};

export const resolveRouteLocale = (query = {}) => {
    return normalizeLocale(query.lang) || normalizeLocale(query.locale);
};

export const resolvePreferredLocale = ({
    search = window.location.search,
    storage = localStorage,
    browser = navigator,
} = {}) => {
    const params = new URLSearchParams(search);
    const browserLocale =
        browser.languages?.find(language => normalizeLocale(language)) ||
        browser.language;

    return (
        normalizeLocale(params.get('lang')) ||
        normalizeLocale(params.get('locale')) ||
        normalizeLocale(storage.getItem('locale')) ||
        normalizeLocale(browserLocale) ||
        DEFAULT_LOCALE
    );
};
